export const basenameForWebApp = '/main';
export const basenameForEmbedApp = '/embed';
export const basenameForTeamsApp = '/teams';
export const basenameForTeamsTabApp = '/teamstab';
export const basenameForTeamsMeetingApp = '/teamsmeeting';
export const basenameForTeamsBrandedExpApp = '/teams-branded-exp';

const basenames: readonly [
  typeof basenameForWebApp,
  typeof basenameForTeamsApp,
  typeof basenameForEmbedApp,
  typeof basenameForTeamsTabApp,
  typeof basenameForTeamsMeetingApp,
  typeof basenameForTeamsBrandedExpApp,
] = [
  basenameForWebApp,
  basenameForTeamsApp,
  basenameForEmbedApp,
  basenameForTeamsTabApp,
  basenameForTeamsMeetingApp,
  basenameForTeamsBrandedExpApp,
];

export type Basename = (typeof basenames)[number];
export type GetBasenames = () => string[];
export const getBasenames: GetBasenames = () => [...basenames];
